export default {"id":"243de595","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}